export default {
  leads: [],
  lead: {},
  statuses: [],
};
